import { FunctionComponent, useEffect, useState } from 'react';
import { useLocalization } from 'Hooks';
import { UsingPhotoDesktop, UsingPhotoMobile } from 'Assets/Images/usingPhoto';
import { PhotoErrorIcon, PhotoSuccessIcon } from 'Components/Svg';
import { Button, Dialog } from '@material-ui/core';
import './PhotoStepPopup.scss';

// Tüm resimleri önceden yükle ve promise döndür
const preloadAllImages = (): Promise<void[]> => {
  const images = [
    ...Object.values(UsingPhotoDesktop),
    ...Object.values(UsingPhotoMobile),
  ];
  
  return Promise.all(
    images.map((src) => {
      return new Promise<void>((resolve) => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = () => resolve(); // Hata durumunda da devam et
        img.src = src;
      });
    })
  );
};

type DialogOTPProps = {
  isOpen: boolean;
  onClick?: () => void;
  buttonText?: string;
};

const PhotoStepPopup: FunctionComponent<DialogOTPProps> = ({ isOpen, onClick = () => {}, buttonText }) => {
  const [imagesLoaded, setImagesLoaded] = useState<boolean>(false);
  
  const {
    web_photo_rules_popup_title,
    web_photo_rules_popup_desc_new,
    web_photo_rules_popup_valid,
    web_photo_rules_popup_invalid,
    web_photo_rules_popup_btn,
  } = useLocalization();

  // Component mount olduğunda resimleri önceden yükle
  useEffect(() => {
    preloadAllImages().then(() => {
      setImagesLoaded(true);
    });
  }, []);

  return (
    <Dialog open={isOpen} onClose={onClick} keepMounted={false} disablePortal={true}>
      <div id="photo_intro">
        <h1>{web_photo_rules_popup_title}</h1>
        <p
          style={{
            marginTop: 20,
          }}
        >
          {web_photo_rules_popup_desc_new?.split('-')?.map((item) => {
            return <p>• {item}</p>;
          })}
        </p>

        <div className="introImagesWeb" style={{ opacity: imagesLoaded ? 1 : 0, transition: 'opacity 0.3s ease-in-out' }}>
          <div className="errorPhoto">
            <img src={UsingPhotoDesktop.Item1} alt="Geçersiz fotoğraf örneği 1" loading="eager" decoding="sync" />
            <div className="error">
              <PhotoErrorIcon />
            </div>
            <span>{web_photo_rules_popup_invalid}</span>
          </div>
          <div className="errorPhoto">
            <img src={UsingPhotoDesktop.Item2} alt="Geçersiz fotoğraf örneği 2" loading="eager" decoding="sync" />
            <div className="error">
              <PhotoErrorIcon />
            </div>
            <span>{web_photo_rules_popup_invalid}</span>
          </div>
          <div className="errorPhoto">
            <img src={UsingPhotoDesktop.Item3} alt="Geçersiz fotoğraf örneği 3" loading="eager" decoding="sync" />
            <div className="error">
              <PhotoErrorIcon />
            </div>
            <span>{web_photo_rules_popup_invalid}</span>
          </div>
          <div className="errorPhoto">
            <img src={UsingPhotoDesktop.Item4} alt="Geçersiz fotoğraf örneği 4" loading="eager" decoding="sync" />
            <div className="error">
              <PhotoErrorIcon />
            </div>
            <span>{web_photo_rules_popup_invalid}</span>
          </div>
          <div className="successPhoto">
            <img src={UsingPhotoDesktop.Item5} alt="Geçerli fotoğraf örneği" loading="eager" decoding="sync" />
            <div className="success">
              <PhotoSuccessIcon />
            </div>
            <span>{web_photo_rules_popup_valid}</span>
          </div>
        </div>
        <div className="introImagesMobil" style={{ opacity: imagesLoaded ? 1 : 0, transition: 'opacity 0.3s ease-in-out' }}>
          <div className="errors">
            <div className="con">
              <div className="errorPhoto">
                <img src={UsingPhotoMobile.Item1} alt="Geçersiz fotoğraf örneği 1" loading="eager" decoding="sync" />
                <div className="error">
                  <PhotoErrorIcon />
                </div>
              </div>
              <div className="errorPhoto">
                <img src={UsingPhotoMobile.Item2} alt="Geçersiz fotoğraf örneği 2" loading="eager" decoding="sync" />
                <div className="error">
                  <PhotoErrorIcon />
                </div>
              </div>
              <div className="errorPhoto">
                <img src={UsingPhotoMobile.Item3} alt="Geçersiz fotoğraf örneği 3" loading="eager" decoding="sync" />
                <div className="error">
                  <PhotoErrorIcon />
                </div>
              </div>
              <div className="errorPhoto">
                <img src={UsingPhotoMobile.Item4} alt="Geçersiz fotoğraf örneği 4" loading="eager" decoding="sync" />
                <div className="error">
                  <PhotoErrorIcon />
                </div>
              </div>
            </div>
            <span>{web_photo_rules_popup_invalid}</span>
          </div>
          <div className="successPhoto">
            <img src={UsingPhotoMobile.Item5} alt="Geçerli fotoğraf örneği" loading="eager" decoding="sync" />
            <div className="success">
              <PhotoSuccessIcon />
            </div>
            <span>{web_photo_rules_popup_valid}</span>
          </div>
        </div>
        <div className="button">
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={onClick}
            type="submit"
            itemID="confirmBtnTest"
          >
            {buttonText ?? web_photo_rules_popup_btn}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default PhotoStepPopup;
